import './SongList.css'

export default function SongList() {
    return (
        <main>
            <h1 className='song-list-header'>Song List:</h1>
            <h2 className="song-list">
                <div className='item'>
                    All Time Low - Dear Maria, Count Me In
                </div>
                <div className='item'>
                    The Ataris - The Boys of Summer
                </div>
                <div className='item'>
                    Backstreet Boys - Everybody (Backstreet's Back)
                </div>
                <div className='item'>
                    Blink-182 - All The Small Things,
                    What's My Age Again
                </div>
                <div className='item'>
                    Buckcherry - Crazy Bitch
                </div>
                <div className='item'>
                    Bush - Machine Head
                </div>
                <div className='item'>
                    Cee Lo Green - Forget You
                </div>
                <div className='item'>
                    Collective Soul - Shine
                </div>
                <div className='item'>
                    Creed - Higher,
                    One Last Breath
                </div>
                <div className='item'>
                    Crossfade - Cold
                </div>
                <div className='item'>
                    Disturbed - Down With The Sickness
                </div>
                <div className='item'>
                    Drowning Pool - Bodies
                </div>
                <div className='item'>
                    Eve 6 - Inside Out
                </div>
                <div className='item'>
                    Fall Out Boy - Sugar, We’re Going Down
                </div>
                <div className='item'>
                    Finger Eleven - Paralyzer
                </div>
                <div className='item'>
                    Foo Fighters - Everlong,
                    Learn To Fly,
                    My Hero
                </div>
                <div className='item'>
                    Good Charlotte - The Anthem
                </div>
                <div className='item'>
                    Green Day - Basket Case,
                    When I Come Around
                </div>
                <div className='item'>
                    Guns N’ Roses - Sweet Child O’ Mine
                </div>
                <div className='item'>
                    Jet - Cold Hard Bitch
                </div>
                <div className='item'>
                    Jimmy Eat World - The Middle
                </div>
                <div className='item'>
                    The Killers - Mr. Brightside
                </div>
                <div className='item'>
                    Linkin Park - Bleed It Out,
                    In The End,
                    One Step Closer,
                    Somewhere I Belong
                </div>
                <div className='item'>
                    Lit - My Own Worst Enemy
                </div>
                <div className='item'>
                    Metallica - Enter Sandman,
                    For Whom The Bell Tolls
                </div>
                <div className='item'>
                    Nickelback - How You Remind Me,
                    Rockstar
                </div>
                <div className='item'>
                    Nirvana - Smells Like Teen Spirit
                </div>
                <div className='item'>
                    NSYNC - Bye Bye Bye
                </div>
                <div className='item'>
                    Papa Roach - Last Resort,
                    Scars
                </div>
                <div className='item'>
                    Pearl Jam - Even Flow
                </div>
                <div className='item'>
                    Post Malone - I Had Some Help
                </div>
                <div className='item'>
                    Rage Against The Machine - Bulls On Parade,
                    Killing In The Name
                </div>
                <div className='item'>
                    Seether - Remedy
                </div>
                <div className='item'>
                    Shaggy - It Wasn't Me
                </div>
                <div className='item'>
                    Stone Temple Pilots - Interstate Love Song
                </div>
                <div className='item'>
                    Sum 41 - Fat Lip,
                    In Too Deep
                </div>
                <div className='item'>
                    Third Eye Blind - Jumper
                </div>
                <div className='item'>
                    Three Days Grace - Animal I Have Become
                </div>
                <div className='item'>
                    Tool - Sober
                </div>
                <div className='item'>
                    3 Doors Down - Kryptonite
                </div>
                <div className='item'>
                    Usher - Yeah!
                </div>
                <div className='item'>
                    WALK THE MOON - Shut Up and Dance
                </div>
                <div className='item'>
                    The Weeknd - Blinding Lights
                </div>
            </h2>
            <br />
        </main>
    )
}
